import { DtoMapper } from '@wemogy/reactbase';
import {IDataStructureTemplate} from '../../models/DataStructureTemplate';

export default class DataStructureTemplateDtoMapper extends DtoMapper<IDataStructureTemplate, any>{

}
